import { ReactElement } from 'react';
import { Box } from '@mui/material';
import { keyframes, styled } from '@mui/material/styles';
import WhatAbilityLogo from '@/assets/logo/what-ability-logo.png';

const grow = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.5); }
  100% { transform: scale(1); }
`;

const AnimatedBox = styled(Box)({
  width: 240,
  height: 240,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  animation: `${grow} 1s infinite ease`,
});

export const SystemLoadingIcon = () => {
  return (
    <AnimatedBox>
      <img
        src={WhatAbilityLogo}
        alt="Logo"
        style={{ height: 60 }}
      />
    </AnimatedBox>
  );
};

export const AppLoader = (): ReactElement => {
  return (
    <Box
      width="100vw"
      height="100vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        backgroundColor: 'rgba(255, 255, 255, 0.1)',
      }}
    >
      <SystemLoadingIcon />
    </Box>
  );
};
